import { BgTasksView } from "../components/BgTasksView";

// Background tasks view for any authenticated user — shows only the tasks the
// current user has triggered (scoping is enforced by the backend).
export function MyBgTasksPage() {
  return <BgTasksView title="Moje zadania w tle" />;
}
